import { IconWrapper } from '@geneo2-web/shared-ui';
import { Divider, Typography } from '@mui/material';
import { Box, SxProps } from '@mui/system';
import { pxToRem, pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { IStyles } from 'libs/shared-ui/src/commonUtils/styleUtils';
import index from 'libs/shared-ui/src/components/composites/LoginPage';

const styles: IStyles = {
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    boxSizing: 'border-box',
    gap: pxTovW(10),
  },
  item: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pxTovW(5),
    '&>div': {
      display: 'flex',
      gap: pxTovW(5),
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
};
interface IProps {
  contentList: IContentList[];
  rootStyles?: SxProps;
}
interface IContentList {
  iconName: string;
  heading: string | number;
  headingSubText?: string;
  subHeading: string;
}
export const InfoBarComponent = (props: IProps) => {
  const { contentList, rootStyles } = props;
  let rootSx = { ...styles.root };
  if (rootStyles) rootSx = { ...rootSx, ...rootStyles };
  return (
    <Box sx={rootSx}>
      {contentList.map((e, index) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: pxTovW(5),
            width: '100%',
          }}
        >
          <Box key={index} sx={styles.item}>
            <Box>
              <IconWrapper
                name={e.iconName}
                size="md"
                type="png"
                parentFolder="icons"
              />
              <Typography variant="h3" fontWeight={700}>
                {e.heading}
              </Typography>
              {e.headingSubText ? (
                <Typography variant="smallText">{e.headingSubText}</Typography>
              ) : (
                <></>
              )}
            </Box>
            <Box>
              <Typography variant="smallText">{e.subHeading}</Typography>
            </Box>
          </Box>
          {index < contentList.length - 1 ? (
            <Divider
              orientation="vertical"
              sx={{
                marginLeft: 'auto',
                border: ' 1px dashed lightgrey',
                height: '50px',
                my: 1,
              }}
            />
          ) : (
            <></>
          )}
        </Box>
      ))}
    </Box>
  );
};
